import data from "../../.sourceflow/committee.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getCommittee = (locale = "en") => {
  return new BaseCollection(data, locale).orderBy((i) => parseInt(i["_order"])).getItems();
};
